import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import { LayoutComponent } from './layout.component';
import { TopComponent } from './top/top.component';
import { MenuComponent } from './menu/menu.component';
import { ConteudoComponent } from './conteudo/conteudo.component';
import { ViewsModule } from './views/views.module';
import { FooterComponent } from './footer/footer.component';
import { AppRoutingModule } from '../app-routing.module';
import { DestaqueComponent } from './conteudo/destaque/destaque.component';
import { PaginaComponent } from './pagina/pagina.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { SnackbarComponent } from './shared/messages/snackbar/snackbar.component';
import { NoSanitizePipe } from './shared/pipe/noSanitize.pipe';
import { NoticiaDetalheComponent } from './noticia-detalhe/noticia-detalhe.component';
import { NoticiasComponent } from './noticias/noticias.component';
import { SliderNoticiasComponent } from './conteudo/sliderNoticias/sliderNoticias.component';
import { SliderEventosComponent } from './conteudo/sliderEventos/sliderEventos.component';
import { DestaqueNoticiaComponent } from './conteudo/destaqueNoticia/destaqueNoticia.component';
import { EventosComponent } from './conteudo/eventos/eventos.component';
import { EnqueteComponent } from './conteudo/enquete/enquete.component';
import { VideosComponent } from './videos/videos.component';
import { VideosDetalheComponent } from './video-detalhe/video-detalhe.component';
import { DescricaoReduzida } from './shared/pipe/descricao-reduzida.pipe';
import { BrowserModule } from '@angular/platform-browser';
import { RadioComponent } from './shared/radio/radio.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CheckboxComponent } from './shared/checkbox/checkbox.component';
import { PesquisaComponent } from './pesquisa/pesquisa.component';
import { NullComponent } from './not-found/null.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ViewsModule
  ],
  declarations: [
    LayoutComponent,
    TopComponent,
    MenuComponent,
    ConteudoComponent,
    FooterComponent,
    SliderNoticiasComponent,
    DestaqueComponent,
    PaginaComponent,
    NotFoundComponent,
    SnackbarComponent,
    NoSanitizePipe,
    NoticiasComponent,
    NoticiaDetalheComponent,
    VideosComponent,
    SliderEventosComponent,
    DestaqueNoticiaComponent,
    EventosComponent,
    EnqueteComponent,
    VideosDetalheComponent,
    DescricaoReduzida,
    RadioComponent,
    CheckboxComponent,
    PesquisaComponent,
    NullComponent
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    LayoutComponent,
    TopComponent,
    MenuComponent,
    ConteudoComponent,
    FooterComponent,
    SnackbarComponent,
    RadioComponent,
    CheckboxComponent
  ]
})
export class LayoutModule { }
